// plugins/axios.js
import axios from 'axios';

export function createAxios(store) {
    const instance = axios.create({
        baseURL: (process.env.VUE_APP_API_BASE || 'https://api.moovr.dk/v1') + '/',
        headers: { 'Cache-Control': 'no-cache' }
    });

    instance.interceptors.request.use(config => {
        config.params = { _cache: Date.now() };

        // always pull the latest token from Vuex
        const token = store.getters['auth'];
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete config.headers.Authorization;
        }

        return config;
    });

    return instance;
}

export default {
    install(app, { store }) {
        const api = createAxios(store);
        app.config.globalProperties.axios = api;
        app.provide('axios', api);
        store.axios = api; // 👈 use this inside Vuex
    }
};
